import * as Yup from "yup";

export const depositValidation = Yup.object().shape({
  amount: Yup.string().required("وارد کردن مبلغ الزامی است"),
  description: Yup.string().required("وارد کردن توضیحات الزامی است"),
});
